<template>
  
    <el-container>
     
      <el-main>
       <h1>Short cut</h1>
       <table>
<thead>
<tr>
<th>feature</th>
<th>short cut</th>
</tr>
</thead>
<tbody>

<tr>
<td>New Mind Map</td>
<td>Ctrl/Cmd+P</td>
</tr>
<tr>
<td>New child node</td>
<td>Tab</td>
</tr>
<tr>
<td>New brother node</td>
<td>enter</td>
</tr>
<tr>
<td>Delete node</td>
<td>Delete/Backspace</td>
</tr>
<tr>
<td>edit node</td>
<td>Space/dblclick node</td>
</tr>
<tr>
<td>Undo</td>
<td>Ctrl/Cmd+Z</td>
</tr>
<tr>
<td>Redo</td>
<td>Ctrl/Cmd+Y</td>
</tr>
<tr>
<td>Quit edit node</td>
<td>Tab</td>
</tr>
<tr>
<td>Expand node</td>
<td>Ctrl/Cmd + /</td>
</tr>
<tr>
<td>Collapse node</td>
<td>Ctrl/Cmd + /</td>
</tr>
<tr>
<td>Move node to another node</td>
<td>Drag and drop node</td>
</tr>
<tr>
<td>Tab node</td>
<td>Up/down/left/right</td>
</tr>
<tr>
<td>Zoom in/out</td>
<td>Ctrl/Cmd + mouse wheel</td>
</tr>
<tr>
<td>Mind map to center</td>
<td>Ctrl/Cmd + E</td>
</tr>
<tr>
<td>Change mindmap layout</td>
<td>select node,Ctrl/Cmd + U / D / L / R / M / J / K / T / Q</td>
</tr>
<tr>
<td>delete summary / boundary / relate link</td>
<td>Delete/Backspace</td>
</tr>
</tbody>
</table>
      
      </el-main>
    </el-container>
 
</template>

<script>
export default {
  name: 'shortcutPage',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
